import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import Datepicker from "../../material/datepicker/Datepicker";
import { useEffect } from "react";

const InformationRegistration = ({
  pid,
  setPid,
  laserId,
  setLaserId,
  pname,
  setPname,
  fname,
  setFname,
  lname,
  setLname,
  gender,
  setGender,
  birthday,
  setBirthday,

  disableLaser,
  disablePname,
  disableFname,
  disableLname,
  disableGender,
  disableBirthDate,

  regex,
  handleCheckInformation,
  setIsVerified,
  isVerified,
}) => {
  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];

  let pnameList = [
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    { key: "นางสาว", value: "นางสาว" },
  ];

  useEffect(() => {
    if (pname === "น.ส.") {
      setPname("นางสาว");
    }
  }, [pname]);

  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
        ข้อมูลส่วนตัว
      </div>

      <div className="max-w-[1000px] mx-auto mt-5 space-y-6">
        <div className="grid grid-cols-12 gap-4 items-end">
          <div className="col-span-6 md:col-span-8 2sm:col-span-12">
            <Input
              label="เลขบัตรประจำตัวประชาชน"
              placeholder="เลขบัตรประจำตัวประชาชน"
              value={pid}
              setValue={setPid}
              regex={regex.pid()}
              maxLength={13}
            />
          </div>

          <div className="col-span-3 md:col-span-4 2sm:col-span-12">
            {!isVerified ? (
              <button
                onClick={handleCheckInformation}
                className="w-full h-[40px] rounded-[4px] 
                    bg-white border border-[#046839]
                    text-[#046839] text-[16px]
                    hover:bg-[#046839] hover:text-white
                    transition 
                    mb-[6px]"
              >
                {" "}
                ตรวจสอบข้อมูล{" "}
              </button>
            ) : (
              <button
                onClick={() => setIsVerified(false)}
                className="w-full h-[40px] rounded-[4px] 
                    bg-gray-700 border-gray-200
                    text-white text-[16px]
                    hover:bg-gray-500 hover:text-white
                    transition 
                    mb-[6px]"
              >
                แก้ไขเลขบัตร
              </button>
            )}
            {/* <button
              className="w-full h-[40px] rounded-[4px] 
                   bg-white border border-[#046839]
                   text-[#046839] text-[16px]
                   hover:bg-[#046839] hover:text-white
                   transition 
                   mb-[6px]"
              onClick={handleCheckInformation}
            >
              ตรวจสอบข้อมูล
            </button> */}
          </div>
        </div>

        {isVerified && (
          <>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6 2sm:col-span-12">
                <Input
                  label="เลขหลังบัตรประจำตัวประชาชน"
                  placeholder="เลขหลังบัตรประจำตัวประชาชน"
                  value={laserId}
                  setValue={setLaserId}
                  regex={regex.laserId()}
                  disabled={disableLaser}
                  maskPid
                />
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-2 lg:col-span-12">
                <Select
                  label="เลือกคำนำหน้า"
                  disabled={disablePname}
                  value={pname}
                  setValue={setPname}
                  list={pnameList}
                  placeholder="เลือกคำนำหน้า"
                />
              </div>

              <div className="col-span-5 lg:col-span-6 md:col-span-12">
                <Input
                  disabled={disableFname}
                  label="ชื่อ"
                  placeholder="ชื่อ"
                  value={fname}
                  setValue={setFname}
                />
              </div>

              <div className="col-span-5 lg:col-span-6 md:col-span-12">
                <Input
                  disabled={disableLname}
                  label="นามสกุล"
                  placeholder="นามสกุล"
                  value={lname}
                  setValue={setLname}
                />
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6 md:col-span-12">
                <Select
                  disabled={disableGender}
                  label="เพศ"
                  placeholder="เพศ"
                  value={gender}
                  setValue={setGender}
                  list={genderList}
                />
              </div>

              <div className="col-span-6 md:col-span-12">
                <Datepicker
                  disabled={disableBirthDate}
                  label="วันเกิด"
                  value={birthday}
                  setValue={setBirthday}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InformationRegistration;
